import React, { useReducer } from "react";
import { keyIsLetterOrNumber } from "../store/api/CommonFunctions";

const CustomSelect = React.forwardRef(({ value, onChange, options, placeholder, className }, ref) => {
  const [open, setOpen] = React.useState(false);
  const [highlightedIndex, setHighlightedIndex] = React.useState(-1);
  const innerRef = React.useRef();
  const searchedText = React.useRef("");
  const searchTimeout = React.useRef();
  React.useImperativeHandle(ref, () => ({
    open: () => { setOpen(true); innerRef.current?.focus() },
    close: () => setOpen(false),
    toggle: () => setOpen(prev => !prev),
  }));
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (innerRef.current && !innerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleKeyDown = (e) => {
    if (!open) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex(prev => (prev + 1) % options.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex(prev => (prev - 1 + options.length) % options.length);
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0) {
        onChange(options[highlightedIndex].value);
        setOpen(false);
      }
    } else if (e.key === "Escape") {
      e.preventDefault();
      setOpen(false);

    }
    else if (keyIsLetterOrNumber('', e.key)) {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
      searchedText.current += e.key;
      const textExists = e.target.innerText.contains(searchedText.current);
      const el = e.target.querySelectorAll(".option");
      for (let i = 0; i < el.length; i++) {
        if (textExists) {
          el[i].style.display = "none";
        }
        if (searchedText.current?.length > 0 && el[i].innerText.contains(searchedText.current)) {
          el[i].style.display = "block";
        }
      }
      searchTimeout.current = setTimeout(() => {
        searchedText.current = '';
      }, 1500)
    }
  };
  const handleSelect = (val, index) => {
    onChange(val);
    setOpen(false);
    setHighlightedIndex(index);
  };
  return (
    <div className={`custom-select ${className}`} ref={innerRef} style={{ padding: 0 }}
      tabIndex={0}
      onKeyDown={handleKeyDown}>
      <div className="selected-value" style={{ padding: ".375rem .75rem" }}
        onClick={() => {
          setOpen(prev => !prev);
          if (!open)
            setHighlightedIndex(0); // وقتی باز می‌شود اولین گزینه highlight
        }}>
        {value ? options.find(o => o.value === value)?.label : placeholder}
      </div>
      {open && (
        <div className="options scThin">
          {options.map((opt, index) => (
            <div
              key={opt.value}
              ref={el => {
                if (el && index === highlightedIndex) {
                  el.scrollIntoView({ block: "nearest" }); // scroll خودکار
                }
              }}
              className={`option ${index === highlightedIndex ? "highlighted" : ""}`}
              onMouseEnter={() => setHighlightedIndex(index)}
              onClick={() => handleSelect(opt.value, index)}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
});
export default CustomSelect;
